var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-list-wrapper"},[_vm._l((_vm.listing),function(item,index){return _c('content-item',{key:item.DetailID,attrs:{"item":item}})}),_vm._v(" "),_c('pagination')],2)}
var staticRenderFns = []

export { render, staticRenderFns }